"use strict";

var _regeneratorRuntime = require("/Users/nobuaquino/Macrometa/Demos/crypto_trading_bot/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/nobuaquino/Macrometa/Demos/crypto_trading_bot/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/nobuaquino/Macrometa/Demos/crypto_trading_bot/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/nobuaquino/Macrometa/Demos/crypto_trading_bot/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/nobuaquino/Macrometa/Demos/crypto_trading_bot/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/nobuaquino/Macrometa/Demos/crypto_trading_bot/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var collection_1 = require("./collection");

var error_1 = require("./error");

var GraphVertexCollection = /*#__PURE__*/function (_collection_1$BaseCol) {
  _inherits(GraphVertexCollection, _collection_1$BaseCol);

  function GraphVertexCollection(connection, name, graph) {
    var _this;

    _classCallCheck(this, GraphVertexCollection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GraphVertexCollection).call(this, connection, name));
    _this.type = collection_1.CollectionType.DOCUMENT_COLLECTION;
    _this.graph = graph;
    return _this;
  }

  _createClass(GraphVertexCollection, [{
    key: "document",
    value: function document(documentHandle) {
      var graceful = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var result = this._connection.request({
        path: "/_api/graph/".concat(this.graph.name, "/vertex/").concat(this._documentHandle(documentHandle))
      }, function (res) {
        return res.body.vertex;
      });

      if (!graceful) return result;
      return result.catch(function (err) {
        if (error_1.isC8Error(err) && err.errorNum === collection_1.DOCUMENT_NOT_FOUND) {
          return null;
        }

        throw err;
      });
    }
  }, {
    key: "vertex",
    value: function vertex(documentHandle) {
      var graceful = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.document(documentHandle, graceful);
    }
  }, {
    key: "save",
    value: function save(data, opts) {
      return this._connection.request({
        method: "POST",
        path: "/_api/graph/".concat(this.graph.name, "/vertex/").concat(this.name),
        body: data,
        qs: opts
      }, function (res) {
        return res.body.vertex;
      });
    }
  }, {
    key: "replace",
    value: function replace(documentHandle, newValue) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _a;

      var headers = {};

      if (typeof opts === "string") {
        opts = {
          rev: opts
        };
      }

      if (opts.rev) {
        var _a2;

        var rev;
        _a = opts, (_a2 = _a, rev = _a2.rev, _a2), opts = __rest(_a, ["rev"]);
        headers["if-match"] = rev;
      }

      return this._connection.request({
        method: "PUT",
        path: "/_api/graph/".concat(this.graph.name, "/vertex/").concat(this._documentHandle(documentHandle)),
        body: newValue,
        qs: opts,
        headers: headers
      }, function (res) {
        return res.body.vertex;
      });
    }
  }, {
    key: "update",
    value: function update(documentHandle, newValue) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _a;

      var headers = {};

      if (typeof opts === "string") {
        opts = {
          rev: opts
        };
      }

      if (opts.rev) {
        var _a3;

        var rev;
        _a = opts, (_a3 = _a, rev = _a3.rev, _a3), opts = __rest(_a, ["rev"]);
        headers["if-match"] = rev;
      }

      return this._connection.request({
        method: "PATCH",
        path: "/_api/graph/".concat(this.graph.name, "/vertex/").concat(this._documentHandle(documentHandle)),
        body: newValue,
        qs: opts,
        headers: headers
      }, function (res) {
        return res.body.vertex;
      });
    }
  }, {
    key: "remove",
    value: function remove(documentHandle) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a;

      var headers = {};

      if (typeof opts === "string") {
        opts = {
          rev: opts
        };
      }

      if (opts.rev) {
        var _a4;

        var rev;
        _a = opts, (_a4 = _a, rev = _a4.rev, _a4), opts = __rest(_a, ["rev"]);
        headers["if-match"] = rev;
      }

      return this._connection.request({
        method: "DELETE",
        path: "/_api/graph/".concat(this.graph.name, "/vertex/").concat(this._documentHandle(documentHandle)),
        qs: opts,
        headers: headers
      }, function (res) {
        return res.body.removed;
      });
    }
  }]);

  return GraphVertexCollection;
}(collection_1.BaseCollection);

exports.GraphVertexCollection = GraphVertexCollection;

var GraphEdgeCollection = /*#__PURE__*/function (_collection_1$EdgeCol) {
  _inherits(GraphEdgeCollection, _collection_1$EdgeCol);

  function GraphEdgeCollection(connection, name, graph) {
    var _this2;

    _classCallCheck(this, GraphEdgeCollection);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(GraphEdgeCollection).call(this, connection, name));
    _this2.type = collection_1.CollectionType.EDGE_COLLECTION;
    _this2.type = collection_1.CollectionType.EDGE_COLLECTION;
    _this2.graph = graph;
    return _this2;
  }

  _createClass(GraphEdgeCollection, [{
    key: "document",
    value: function document(documentHandle) {
      var graceful = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var result = this._connection.request({
        path: "/_api/graph/".concat(this.graph.name, "/edge/").concat(this._documentHandle(documentHandle))
      }, function (res) {
        return res.body.edge;
      });

      if (!graceful) return result;
      return result.catch(function (err) {
        if (error_1.isC8Error(err) && err.errorNum === collection_1.DOCUMENT_NOT_FOUND) {
          return null;
        }

        throw err;
      });
    }
  }, {
    key: "save",
    value: function save(data, fromId, toId, opts) {
      if (fromId !== undefined) {
        if (toId !== undefined) {
          data._from = this._documentHandle(fromId);
          data._to = this._documentHandle(toId);
        } else {
          opts = fromId;
        }
      }

      return this._connection.request({
        method: "POST",
        path: "/_api/graph/".concat(this.graph.name, "/edge/").concat(this.name),
        body: data,
        qs: opts
      }, function (res) {
        return res.body.edge;
      });
    }
  }, {
    key: "replace",
    value: function replace(documentHandle, newValue) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _a;

      var headers = {};

      if (typeof opts === "string") {
        opts = {
          rev: opts
        };
      }

      if (opts.rev) {
        var _a5;

        var rev;
        _a = opts, (_a5 = _a, rev = _a5.rev, _a5), opts = __rest(_a, ["rev"]);
        headers["if-match"] = rev;
      }

      return this._connection.request({
        method: "PUT",
        path: "/_api/graph/".concat(this.graph.name, "/edge/").concat(this._documentHandle(documentHandle)),
        body: newValue,
        qs: opts,
        headers: headers
      }, function (res) {
        return res.body.edge;
      });
    }
  }, {
    key: "update",
    value: function update(documentHandle, newValue) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _a;

      var headers = {};

      if (typeof opts === "string") {
        opts = {
          rev: opts
        };
      }

      if (opts.rev) {
        var _a6;

        var rev;
        _a = opts, (_a6 = _a, rev = _a6.rev, _a6), opts = __rest(_a, ["rev"]);
        headers["if-match"] = rev;
      }

      return this._connection.request({
        method: "PATCH",
        path: "/_api/graph/".concat(this.graph.name, "/edge/").concat(this._documentHandle(documentHandle)),
        body: newValue,
        qs: opts,
        headers: headers
      }, function (res) {
        return res.body.edge;
      });
    }
  }, {
    key: "remove",
    value: function remove(documentHandle) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a;

      var headers = {};

      if (typeof opts === "string") {
        opts = {
          rev: opts
        };
      }

      if (opts.rev) {
        var _a7;

        var rev;
        _a = opts, (_a7 = _a, rev = _a7.rev, _a7), opts = __rest(_a, ["rev"]);
        headers["if-match"] = rev;
      }

      return this._connection.request({
        method: "DELETE",
        path: "/_api/graph/".concat(this.graph.name, "/edge/").concat(this._documentHandle(documentHandle)),
        qs: opts,
        headers: headers
      }, function (res) {
        return res.body.removed;
      });
    }
  }]);

  return GraphEdgeCollection;
}(collection_1.EdgeCollection);

exports.GraphEdgeCollection = GraphEdgeCollection;
var GRAPH_NOT_FOUND = 1924;

var Graph = /*#__PURE__*/function () {
  function Graph(connection, name) {
    _classCallCheck(this, Graph);

    this.name = name;
    this._connection = connection;
  }

  _createClass(Graph, [{
    key: "get",
    value: function get() {
      return this._connection.request({
        path: "/_api/graph/".concat(this.name)
      }, function (res) {
        return res.body.graph;
      });
    }
  }, {
    key: "exists",
    value: function exists() {
      return this.get().then(function () {
        return true;
      }, function (err) {
        if (error_1.isC8Error(err) && err.errorNum === GRAPH_NOT_FOUND) {
          return false;
        }

        throw err;
      });
    }
  }, {
    key: "create",
    value: function create() {
      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._connection.request({
        method: "POST",
        path: "/_api/graph",
        body: Object.assign({}, properties, {
          name: this.name
        })
      }, function (res) {
        return res.body.graph;
      });
    }
  }, {
    key: "drop",
    value: function drop() {
      var dropCollections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._connection.request({
        method: "DELETE",
        path: "/_api/graph/".concat(this.name),
        qs: {
          dropCollections: dropCollections
        }
      }, function (res) {
        return res.body.removed;
      });
    }
  }, {
    key: "vertexCollection",
    value: function vertexCollection(collectionName) {
      return new GraphVertexCollection(this._connection, collectionName, this);
    }
  }, {
    key: "listVertexCollections",
    value: function listVertexCollections() {
      return this._connection.request({
        path: "/_api/graph/".concat(this.name, "/vertex")
      }, function (res) {
        return res.body.collections;
      });
    }
  }, {
    key: "vertexCollections",
    value: function vertexCollections() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var names;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.listVertexCollections();

              case 2:
                names = _context.sent;
                return _context.abrupt("return", names.map(function (name) {
                  return new GraphVertexCollection(_this3._connection, name, _this3);
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "addVertexCollection",
    value: function addVertexCollection(collection) {
      if (collection_1.isC8Collection(collection)) {
        collection = collection.name;
      }

      return this._connection.request({
        method: "POST",
        path: "/_api/graph/".concat(this.name, "/vertex"),
        body: {
          collection: collection
        }
      }, function (res) {
        return res.body.graph;
      });
    }
  }, {
    key: "removeVertexCollection",
    value: function removeVertexCollection(collection) {
      var dropCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (collection_1.isC8Collection(collection)) {
        collection = collection.name;
      }

      return this._connection.request({
        method: "DELETE",
        path: "/_api/graph/".concat(this.name, "/vertex/").concat(collection),
        qs: {
          dropCollection: dropCollection
        }
      }, function (res) {
        return res.body.graph;
      });
    }
  }, {
    key: "edgeCollection",
    value: function edgeCollection(collectionName) {
      return new GraphEdgeCollection(this._connection, collectionName, this);
    }
  }, {
    key: "listEdgeCollections",
    value: function listEdgeCollections() {
      return this._connection.request({
        path: "/_api/graph/".concat(this.name, "/edge")
      }, function (res) {
        return res.body.collections;
      });
    }
  }, {
    key: "edgeCollections",
    value: function edgeCollections() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this4 = this;

        var names;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.listEdgeCollections();

              case 2:
                names = _context2.sent;
                return _context2.abrupt("return", names.map(function (name) {
                  return new GraphEdgeCollection(_this4._connection, name, _this4);
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "addEdgeDefinition",
    value: function addEdgeDefinition(definition) {
      return this._connection.request({
        method: "POST",
        path: "/_api/graph/".concat(this.name, "/edge"),
        body: definition
      }, function (res) {
        return res.body.graph;
      });
    }
  }, {
    key: "replaceEdgeDefinition",
    value: function replaceEdgeDefinition(definitionName, definition) {
      return this._connection.request({
        method: "PUT",
        path: "/_api/graph/".concat(this.name, "/edge/").concat(definitionName),
        body: definition
      }, function (res) {
        return res.body.graph;
      });
    }
  }, {
    key: "removeEdgeDefinition",
    value: function removeEdgeDefinition(definitionName) {
      var dropCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this._connection.request({
        method: "DELETE",
        path: "/_api/graph/".concat(this.name, "/edge/").concat(definitionName),
        qs: {
          dropCollection: dropCollection
        }
      }, function (res) {
        return res.body.graph;
      });
    }
  }]);

  return Graph;
}();

exports.Graph = Graph;